import Swal from "sweetalert2";
const HandleErrorService = {
  handleError(msg, callback) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: msg
    });
    if (callback) {
      callback();
    }
  }
};

export default HandleErrorService;



// WEBPACK FOOTER //
// ./src/service/HandleErrorService.js